import { useState } from 'react'
import { Modal, Button, Anchor } from '@mantine/core'
import Box from '@/components/ui/Box'
import ShopifyOrderSelect from '@/components/ui/ShopifyOrderSelect'
import { orderFinancialLabels as financialLabels, orderFulfillmentLabels as fulfillmentLabels } from '@/lib/orderStatuses'
import dayjs from 'dayjs'

export default function ServiceCaseOrder({ serviceCase, updateServiceCase }) {
    const [opened, setOpened] = useState(false)
    const [loading, setLoading] = useState(false)

    const order = serviceCase.order

    const handleSelectOrder = async (selected) => {
        setLoading(true)
        await updateServiceCase({ order_id: selected.id })
        setLoading(false)
        setOpened(false)
    }

    const handleUnlink = async () => {
        setLoading(true)
        await updateServiceCase({ order_id: null })
        setLoading(false)
    }

    const customerName = order
        ? [order.customer?.first_name, order.customer?.last_name].filter(Boolean).join(' ')
        : null

    const financial = financialLabels[order?.financial_status]
    const fulfillment = fulfillmentLabels[order?.fulfillment_status] || (order?.fulfillment_status === null ? { label: 'Non expédié', color: 'text-orange-500' } : null)

    const rightSection = order ? (
        <Button
            variant="default"
            size="sm"
            onClick={(e) => { e.stopPropagation(); handleUnlink() }}
            loading={loading}
        >
            Désassocier
        </Button>
    ) : null

    return (
        <>
            <Box
                title="Commande"
                rightSection={rightSection}
                globalAction={true}
                action={() => setOpened(true)}
                actionLabel={order ? 'Modifier' : 'Associer une commande'}
            >
                <div className="flex flex-col gap-2">
                    {serviceCase.order_number && (
                        <div className="flex items-center gap-2 text-sm">
                            <span className="text-gray-400">Réf. client :</span>
                            <span>{serviceCase.order_number}</span>
                        </div>
                    )}

                    {order ? (
                        <div className="flex items-center gap-2 flex-wrap text-sm">
                            <Anchor href={`/orders/${order.id}`} size="sm" fw={500} onClick={(e) => e.stopPropagation()}>
                                {order.name}
                            </Anchor>
                            <span className="text-gray-300">·</span>
                            <span className="text-gray-500">
                                {dayjs(order.shopify_created_at || order.created_at).format('D MMMM YYYY')}
                            </span>
                            {customerName && (
                                <>
                                    <span className="text-gray-300">·</span>
                                    <span className="text-gray-500">{customerName}</span>
                                </>
                            )}
                            {financial && (
                                <>
                                    <span className="text-gray-300">·</span>
                                    <span className={`text-xs ${financial.color}`}>{financial.label}</span>
                                </>
                            )}
                            {fulfillment && (
                                <>
                                    <span className="text-gray-300">·</span>
                                    <span className={`text-xs ${fulfillment.color}`}>{fulfillment.label}</span>
                                </>
                            )}
                        </div>
                    ) : (
                        !serviceCase.order_number && (
                            <span className="text-gray-400 text-sm">Aucune commande associée</span>
                        )
                    )}
                </div>
            </Box>

            <Modal
                opened={opened}
                onClose={() => setOpened(false)}
                title="Associer une commande Shopify"
                centered
            >
                <ShopifyOrderSelect
                    onSelect={handleSelectOrder}
                />
            </Modal>
        </>
    )
}
